import { StreamingUpdate, StreamingUpdateReason } from './types.ts';

const handleServerSideEvents = (
    line: string,
    handleEventData: (streamingUpdate: StreamingUpdate) => void
) => {
    if (line.startsWith('data: ')) {
        const jsonString = line.slice(6); // Remove 'data: ' prefix

        if (jsonString === '[DONE]') {
            // Handle end of stream
            handleEventData({
                updateKind: StreamingUpdateReason.Done
            });
            return;
        }

        if (jsonString === '[ERROR]') {
            // Handle errors in the stream
            handleEventData({
                updateKind: StreamingUpdateReason.Error
            });
            return;
        }

        let streamingUpdate: StreamingUpdate | null = null;

        try {
            streamingUpdate = JSON.parse(jsonString);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            console.log(jsonString);
        }

        if (streamingUpdate) {
            handleEventData(streamingUpdate);
        }
    }
};

export default handleServerSideEvents;
